module.exports = __webpack_public_path__ + "img/skill_develop.d93f850c.svg";